<!-- Single wrapper that adapts based on group mode -->
<div
  [class.p-inputgroup]="group"
  [class.input-container]="!group"
  [style.display]="!group ? 'flex' : null"
  [style.align-items]="!group ? 'center' : null"
  [style.gap]="!group ? '8px' : null"
  [ngStyle]="sizeVars"
>
  <!-- Prepend (only in group mode) -->
  <span *ngIf="group && preLabel" class="p-inputgroup-addon">{{
    preLabel
  }}</span>
  <ng-container *ngIf="group && preContent && !preLabel">
    <span class="p-inputgroup-addon">
      <ng-content select="pre-content"></ng-content>
    </span>
  </ng-container>

  <!-- Single Input Number -->
  <p-inputNumber
    class="p-inputnumber"
    #inputModel="ngModel"
    [useGrouping]="useGrouping"
    [ngModel]="value"
    (ngModelChange)="onValueChange($event)"
    [placeholder]="placeholder || ''"
    [disabled]="disabled"
    [required]="required"
    [min]="min"
    [max]="max"
    [step]="step"
    [ngClass]="{
      'is-valid': isValid,
      'is-invalid': isInvalid,
    }"
    [inputId]="key"
    [name]="key ?? ''"
    [style]="group ? { width: '100%' } : { flex: 1 }"
    [maxlength]="maxCharacters ?? null"
    [minFractionDigits]="0"
    [maxFractionDigits]="disableDecimals ? 0 : 6"
  ></p-inputNumber>

  <!-- Custom Spinner Buttons (only in group mode) -->
  <div *ngIf="group" class="custom-spinner-buttons">
    <button
      type="button"
      class="spinner-button spinner-button-up"
      (click)="increment()"
      [disabled]="disabled || isMaxReached()"
      [attr.aria-label]="'Increase value'"
    >
      <i class="pi pi-angle-up"></i>
    </button>
    <button
      type="button"
      class="spinner-button spinner-button-down"
      (click)="decrement()"
      [disabled]="disabled || isMinReached()"
      [attr.aria-label]="'Decrease value'"
    >
      <i class="pi pi-angle-down"></i>
    </button>
  </div>

  <!-- Append (only in group mode) -->
  <span *ngIf="group && postLabel" class="p-inputgroup-addon">{{
    postLabel
  }}</span>
  <ng-container *ngIf="group && postContent && !postLabel">
    <span class="p-inputgroup-addon">
      <ng-content select="post-content"></ng-content>
    </span>
  </ng-container>

  <!-- Clear Button (only in standalone mode) -->
  <op-button-ng
    *ngIf="!group && clearButton && value"
    icon="pi pi-times"
    color="danger"
    [asText]="true"
    (buttonClick)="clearValue()"
  />
</div>

<!-- Errors -->
<small class="text-danger">
  <ng-container *ngIf="required && inputModel?.invalid && inputModel?.touched">
    {{ requiredError }}
  </ng-container>
</small>
